export default __webpack_public_path__ + "static/media/thumb.6ca16934.webp";